import { useState } from "react";
import { List, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./AnketaList.css";
import "../Dokument/DokumentList.css";
import { formatDateTime } from "../../utils/formatDateTime";

function AnketaList({ ankete, onDeleteClick }) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentAnkete = ankete.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(ankete.length / itemsPerPage);

  const handleClickAnketa = (anketaId) => {
    navigate(`/zaposleni/anketa/${anketaId}`);
  };

  return (
    <div className="documents-list-container">
      <List
      locale={{ emptyText: "Nema dostupnih anketa." }}
        header={
          <div className="list-header">
            <div className="anketa-col-placeholder"></div>
            <div className="anketa-col-naslov">Naziv ankete</div>
            <div className="anketa-col-datum">Datum kreiranja</div>
            <div className="anketa-col-datum">Datum važenja</div>
            <div className="anketa-col-status">Status</div>
            <div className="anketa-col-akcije">Akcije</div>
          </div>
        }
        bordered
        dataSource={currentAnkete}
        renderItem={(anketa) => (
          <List.Item onClick={() => handleClickAnketa(anketa.id)}>
            <div className="list-row-dokument">
              <div className="anketa-col-placeholder"></div>
              <div className="anketa-col-naslov">{anketa.naziv}</div>
              <div className="anketa-col-datum">
                {formatDateTime(anketa.datumKreiranja)}
              </div>
              <div className="anketa-col-datum">
                {formatDateTime(anketa.datumVazenja)}
              </div>
              <div className="anketa-col-status">{anketa.statusAnkete}</div>
              <div className="anketa-col-akcije">
                <Button
                  type="text"
                  icon={<DeleteOutlined />}
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteClick(anketa.id);
                  }}
                />
              </div>
            </div>
          </List.Item>
        )}
      ></List>
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Prethodna
          </button>

          <span>
            Stranica {currentPage} od {totalPages}
          </span>

          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            Sljedeća
          </button>
        </div>
      )}
    </div>
  );
}

export default AnketaList;
